import { render } from "./bot-protection-disclaimer.vue?vue&type=template&id=c6547caa"
import script from "./bot-protection-disclaimer.vue?vue&type=script&lang=js"
export * from "./bot-protection-disclaimer.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__